var React = require('react');

function IconAngular (props) {
    return React.createElement("svg",props,[React.createElement("g",{"id":"icomoon-ignore","key":0}),React.createElement("path",{"fill":"#000","d":"M0 169.724l476.358-169.724 489.182 166.706-79.206 630.242-409.975 227.052-403.566-224.036-72.793-630.24z","key":1}),React.createElement("path",{"fill":"#000","d":"M965.53 166.706l-489.18-166.706v1024l409.978-226.678 79.201-630.616z","key":2}),React.createElement("path",{"fill":"#fff","d":"M477.128 119.559l-296.828 660.417 110.886-1.889 59.592-148.977h266.279l65.249 150.866 105.984 1.884-311.163-662.301zM477.882 331.148l100.324 209.703h-188.581l88.257-209.703z","key":3})]);
}

IconAngular.defaultProps = {"version":"1.1","width":"973","height":"1024","viewBox":"0 0 973 1024"};

module.exports = IconAngular;

IconAngular.default = IconAngular;
